import L from "leaflet";
import "./basemaps.css";

/**
 * Fonds de carte communs à toutes les cartes du site, tous sans clé d'API.
 *
 * Le fond « niveaux de gris » s'appuie sur le Plan IGN v2 de la Géoplateforme
 * (données ouvertes, sans clé), désaturé en CSS via la classe `gray-scale-tiles` :
 *  - CARTO a fermé ses tuiles raster sans clé (filigrane « API KEY REQUIRED »
 *    incrusté dans des PNG renvoyés en HTTP 200) ;
 *  - le Light Gray Canvas d'Esri, visuellement plus proche, n'a pas de données
 *    au-delà du zoom 16, or la sélection de parcelle cadastrale se fait à z16+.
 *
 * Le Plan IGN v2 est servi jusqu'au zoom 19 : `maxNativeZoom` évite une salve
 * de 404 au zoom 20, que les cartes autorisent.
 *
 * ⚠ Toute modification d'URL est à reporter dans
 * src/main/resources/static/js/quiz/configMap.js, servi hors bundle webpack.
 */
export const GRAY_SCALE_TILES_URL = 'https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/png&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}';
export const PLAN_TILES_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}';
export const SATELLITE_TILES_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';

export const GRAY_SCALE_TILES_ATTRIBUTION = '&copy; <a href="https://www.ign.fr/">IGN</a> &mdash; Géoplateforme';

export const createGrayScaleLayer = () => L.tileLayer(GRAY_SCALE_TILES_URL, {
    attribution: GRAY_SCALE_TILES_ATTRIBUTION,
    className: 'gray-scale-tiles',
    maxNativeZoom: 19,
    maxZoom: 20
});

export const createPlanLayer = () => L.tileLayer(PLAN_TILES_URL, {
    attribution: '&copy; ESRI contributors'
});

export const createSatelliteLayer = () => L.tileLayer(SATELLITE_TILES_URL, {
    attribution: '&copy; Esri'
});
